<template>
  <div class="tw:bg-white" ref="smartTipsContainer">
    <ContainerLayout class="tw:py-11 tw:flex tw:flex-col">
      <InsightsHeader title="plus_smart_tips_header" subtitle="plus_smart_tips_subtext" />
      <div class="tw:flex tw:flex-col tw:gap-y-4 tw:max-w-full">
        <AmenitiesCard />
        <ImagesCard />
      </div>
    </ContainerLayout>
  </div>
</template>
<script setup>
import ContainerLayout from '@/layouts/ContainerLayout.vue'
import InsightsHeader from '@/components/studioPlus/insights/InsightsHeader.vue'
import AmenitiesCard from '@/components/studioPlus/insights/AmenitiesCard.vue'
import ImagesCard from '@/components/studioPlus/insights/ImagesCard.vue'

import { onMounted, onUnmounted, ref } from 'vue'
import { selectedAccommodationId } from '@/layouts/queries'

import appAnalytics from '@/utils/tracking'

const smartTipsContainer = ref(null)
const isInViewport = ref(false)
let observer = null

onMounted(() => {
  observer = new IntersectionObserver(
    ([entry]) => {
      isInViewport.value = entry.isIntersecting

      if (entry.isIntersecting) {
        appAnalytics.track(appAnalytics.events.SP_PLUS_INSIGHTS_SMART_TIPS_VIEWED, {
          item_id: selectedAccommodationId.value,
        })
        if (observer) {
          observer.disconnect()
          observer = null
        }
      }
    },
    { threshold: 0.1 }
  )

  if (smartTipsContainer.value) {
    observer.observe(smartTipsContainer.value)
  }
})

onUnmounted(() => {
  if (observer) {
    observer.disconnect()
  }
})
</script>
